import React from "react";
import { Spinner } from "react-bootstrap";
import CalendarDashboard from "./CalendarDashboard";
import CalendarOnboard from "./CalendarOnboard";
import useCalendar from "./useCalendar";
import MainLayout from "../MainLayout";

export default () => {
  const { loading, calendarLinked } = useCalendar();
  return (
    <MainLayout activeMenuItem="calendar" pageName="Calendar">
      {loading ? (
        <div className="d-flex justify-content-center align-items-center">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : (
        <>
         
          {calendarLinked && calendarLinked?.data ? (
            <CalendarDashboard />
          ) : (
            <CalendarOnboard />
          )}
        </>
      )}
    </MainLayout>
  );
};
